var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.325f158f3e1cd2ea95968c36452f0a51.svg#j';
                    var viewUrl = 'sprites.325f158f3e1cd2ea95968c36452f0a51.svg#view-j';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 23',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };